import { clsx } from 'clsx';
import type { ReactNode } from 'react';

type Variant = 'accent' | 'gray';

const VARIANT: Record<Variant, string> = {
  accent: 'bg-accent text-accent-text',
  gray:   'bg-fill-2 text-fg-primary',
};

export interface BadgeProps {
  variant?: Variant;
  className?: string;
  children: ReactNode;
}

export function Badge({ variant = 'accent', className, children }: BadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 rounded-full text-[10px] font-bold',
        VARIANT[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
